<div class="chart-container new-chart">
    <canvas #chartCanvas class="graph" [id]="canvasId"></canvas>
    <div id="custom-legend" class="custom-legend-container">
        <div *ngFor="let legendItem of legendItems; let i = index" 
             class="custom-legend-item" 
             (click)="toggleDatasetVisibility(i)"
             [ngClass]="{
                'underlined': isNoneSelected(),
                'selected': isSelected(i) && !isNoneSelected(),
                'deselected': !isSelected(i) && isAnyVisible() && !isNoneSelected()
             }">
            <div class="legend-color-box" [style.backgroundColor]="legendItem.borderColor"
            [ngClass]="{
                'deselected': !isSelected(i) && isAnyVisible() && !isNoneSelected()
             }"
            ></div>
            <span class="legend-label">{{ legendItem.label }}</span>
        </div>
    </div>
    <app-tooltip [title]="tooltipTitle" [data]="tooltipValues" [tooltipId]="tooltipId"></app-tooltip>
</div>